module.exports = __webpack_public_path__ + "static/img/case_2.4e5fee43.jpg";